'use client';

import { useTranslations } from 'next-intl';
import { FlexLogo } from 'assets/icons/FlexLogo';
import styles from './HsaFsaFlexTitle.module.css';

// HSA/FSA offer row title: "Pay using HSA / FSA with [flex]".
export const HsaFsaFlexTitle = () => {
  const t = useTranslations('common');
  return (
    <>
      {t('primaryOffers.hsaFsa.payWith')}{' '}
      <FlexLogo
        label={t('primaryOffers.hsaFsa.flexAlt')}
        className={styles.flexLogo}
      />
    </>
  );
};
